import React from 'react'
import styled from 'styled-components'
import { IconButton } from '@nearpod-packages/base-library'
import GameTooltip from './GameTooltip'
import getFont from '../../../helpers/fonts/fonts'

const AnimationsToggleContainer = styled.div<{ $disableResponsiveResize?: boolean }>`
	@media (max-width: 700px) {
		${(props) =>
			!props.$disableResponsiveResize &&
			`
			display: flex;
			align-items: center;
			justify-content: center;
		`}
	}
`

interface IAnimationsToggleProps {
	enabled: boolean
	onToggle: () => void
	disableResponsiveResize?: boolean
}

const AnimationsToggle: React.FC<IAnimationsToggleProps> = ({ enabled, onToggle, disableResponsiveResize }) => {
	return (
		<AnimationsToggleContainer $disableResponsiveResize={disableResponsiveResize}>
			<IconButton
				data-tooltip-id='btn-animation'
				icon={enabled ? 'motion_photos_paused' : 'motion_blur'}
				size='default'
				subVariant='contained'
				variant='tertiary'
				onClick={onToggle}
				aria-label={enabled ? 'Disable animations' : 'Enable animations'}
				aria-pressed={enabled}
			/>
			<GameTooltip id='btn-animation'>
				<span style={{ fontFamily: getFont('primaryMedium'), fontSize: '12px' }}>
					{enabled ? 'Stop animations' : 'Play animations'}
				</span>
			</GameTooltip>
		</AnimationsToggleContainer>
	)
}

export default AnimationsToggle
